module.exports={
  "Biden": {
    "key": "Biden",
    "name": "Joe Biden",
    "src": "assets/synced/biden.png",
    "credit": "Kent Nishimura/Getty Images",
    "featured": "x",
    "active": true,
    "party": "Dem",
    "color": "#7EA6D7"
  },
  "Biden write-in": {
    "key": "Biden write-in",
    "name": "Joe Biden write-in",
    "src": "assets/synced/biden.png",
    "credit": "Kent Nishimura/Getty Images",
    "featured": "",
    "active": true,
    "party": "Dem",
    "color": "#7EA6D7"
  },
  "Phillips": {
    "key": "Phillips",
    "name": "Dean Phillips",
    "src": "assets/synced/phillips.png",
    "credit": "Kevin Dietsch/Getty Images",
    "featured": "",
    "active": false,
    "party": "Dem",
    "color": "#95B066"
  },
  "Williamson": {
    "key": "Williamson",
    "name": "Marianne Williamson",
    "src": "assets/synced/williamson.png",
    "credit": "Jamie McCarthy/Getty Images",
    "featured": "",
    "active": false,
    "party": "Dem",
    "color": "#EB8628"
  },
  "Trump": {
    "key": "Trump",
    "name": "Donald Trump",
    "src": "assets/synced/trump.png",
    "credit": "Scott Olson/Getty Images",
    "featured": "x",
    "active": true,
    "party": "GOP",
    "color": "#D7685E"
  },
  "DeSantis": {
    "key": "DeSantis",
    "name": "Ron DeSantis",
    "src": "assets/synced/desantis.png",
    "credit": "Micah Green/Bloomberg via Getty Images",
    "featured": "",
    "active": false,
    "party": "GOP",
    "color": "#F5BB4C"
  },
  "Haley": {
    "key": "Haley",
    "name": "Nikki Haley",
    "src": "assets/synced/haley.png",
    "credit": "Theo Wargo/Getty Images",
    "featured": "",
    "active": false,
    "party": "GOP",
    "color": "#9D87B9"
  },
  "Christie": {
    "key": "Christie",
    "name": "Chris Christie",
    "src": "assets/synced/christie.png",
    "credit": "Jim Watson/AFP via Getty Images",
    "featured": "",
    "active": false,
    "party": "GOP",
    "color": "#C5B493"
  },
  "Ramaswamy": {
    "key": "Ramaswamy",
    "name": "Vivek Ramaswamy",
    "src": "assets/synced/ramaswamy.png",
    "credit": "Micah Green/Bloomberg via Getty Images",
    "featured": "",
    "active": false,
    "party": "GOP",
    "color": "#6AAEAE"
  },
  "Hutchinson": {
    "key": "Hutchinson",
    "name": "Asa Hutchinson",
    "src": "assets/synced/hutchinson.png",
    "credit": "Charlie Neibergall/AP Photo",
    "featured": "",
    "active": false,
    "party": "GOP",
    "color": "#E989A0"
  }
}